import styled from 'styled-components';

interface StyledMaintenanceContentProps {
  fontFamily?: string;
  fontColor?: string;
}

export const StyledMaintenanceContent = styled.div<StyledMaintenanceContentProps>`
  font-family: ${(props) => props.fontFamily || 'inherit'};
  font-size: 1.25rem;
  font-weight: 500;
  color: ${(props) => props.fontColor || 'white'};
  text-align: center;
  max-width: 500px;
  word-wrap: break-word;

  a {
    color: ${(props) => props.fontColor || 'white'};
    text-decoration-color: ${(props) => props.fontColor || 'white'};
  }
`;
